// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#6663A6',
        secondary: '#5D8C2E',
        accent: '#EE05F2',
      },
      dark: {
        primary: '#6663A6',
        secondary: '#5D8C2E',
        accent: '#EE05F2',
      },
    },
  },
})
